module.exports = __webpack_public_path__ + "static/media/water-rise.ad829d71.svg";